import { useNavigate } from 'react-router-dom'
import { useUserStore } from '../../stores'
import TwoFactorMigrationGate from '../../components/TwoFactorMigrationGate'

export default function TwoFactorUpgradePage() {
  const navigate = useNavigate()
  const user = useUserStore((s) => s.user)
  const isAuthenticated = useUserStore((s) => s.isAuthenticated)

  if (!isAuthenticated || !user) {
    navigate('/signin', { replace: true })
    return null
  }

  return (
    <TwoFactorMigrationGate
      userId={user.id}
      onDismiss={() => navigate('/home', { replace: true })}
    />
  )
}
